import nonEndPointRelated from "./reducers/nonEndPointRelated";

export const CONFIG = "config";
export const USER_INFO = "userInfo";
export const DASHBOARDS = "dashboards";
export const GLOBAL_FILTERS = "globalFilters";
export const CARD_ONLY_FILTERS = "cardOnlyFilters";
export const VIEW_LAYOUTS = "viewLayouts";
export const VOLUMES = "volumes";
export const ORDERS = "orders";
export const TRUCKS = "trucks";
export const VISUALISATIONS = "visualisations";
export const VISUALISATION_DATA = "visualisationData";
export const RAW_DATA_TYPES = "rawDataTypes";
export const RAW_DATA = "rawData";
export const ITEMS = "items";
export const BULK_EDIT = "bulkEdit";
export const COPY_PREVIOUS_WEEK = "copyPreviousWeek";
export const BULK_DELETE = "bulkDelete";
export const SCENARIOS = "scenarios";
export const SCENARIOS_COMPARE_KPIS = "scenariosCompareKpis";
export const SCENARIOS_COMPARE_DATA = "scenariosCompareData";
export const SCENARIOS_COMPARE_DATA_SUMMARY = "scenariosCompareDataSummary";
export const ARCHIVE_SCENARIO = "archiveScenario";
export const UNARCHIVE_SCENARIO = "unarchiveScenario";
export const DELETE_SCENARIO = "deleteScenario";
export const PERSIST_PARAMS = "persistParams";
export const ITEM_LOOKUPS = "itemLookUps";
export const PUBLISH_SHIFT = "publishShift";
export const PUBLISH_STATUS = "publishStatus";
export const CANCEL_OPTIMISE = "cancelOptimise";
export const CANCEL_STATUS = "cancelStatus";
export const OPTIMISE = "optimise";
export const OPTIMISE_STATUS = "optimiseStatus";
export const OPTIMISE_ISSUES = "optimiseIssues";
export const COPY_SHIFTS = "copyShifts";
export const REPLACE_PLAN = "replacePlan";
export const CLEAR_REPLAN = "clearReplan";
export const CLEAR_OPTIMISE_DATA = "clearOptimiseData";
export const CHECK_IS_OPTIMISE = "checkIsOptimise";
export const DOWNLOAD_GRID_DATA = "downloadGridData";
export const DATA_IS_LINKED = "dataIsLinked";
export const UNLINK_DATA = "unlinkData";
export const EVENTS = "events";
export const EVENTS_SUMMARY = "eventsSummary";
export const EVENTS_SUMMARY_VIEWED = "eventsSummaryViewed";
export const VOLUME_FROM_SOURCE = "volumeFromSource";
export const AVAILABLE_VOLUME_DATA_SOURCES = "availableVolumeDataSources";
export const CURRENT_VOLUMES = "currentVolume";
export const UPDATE_VOLUMES = "updateVolumes";
export const PRE_FLIGHT_DATA = "preFlightData";
export const NON_MAINTAINED_SHIFT_COUNT = "nonMaintainedShiftCount";
export const SYNCS_IN_PROGRESS = "syncsInrogress";
export const KPI_REPORT_PICK_VOLUME = "kpiPickVolume";
export const KPI_COST_SUMMARY = "kpiCostSummary";
export const KPI_UTILISATION_REPORT = "kpiUtilisationReport";
export const KPI_FACILITY_REPORT = "kpiFacilityReport";
export const KPI_STORAGE_REPORT = "kpiStorageReport";
export const KPI_PRODUCTIVITY_REPORT = "kpiProductivityReport";
export const DOWNLOAD_COMPARE_DATA = "downloadCompareData";

export const EVENT_PLANNING_SCENARIOS = "eventPlanningScenarios";
export const EVENT_PLANNING_PEAK_DAYS = "eventPlanningPeakDays";
export const INBOUND_VOLUME = "inboundVolume";
export const EVENT_PLANNING_USER_SELECTED_SCENARIOS =
  "eventPlanningUserSelectedScenarios";
export const EVENT_PLANNING_VOLUME_BY_WEEK = "eventPlanningVolumeByWeek";
export const EVENT_PLANNING_PICK_VOLUME = "eventPlanningPickVolume";
export const EVENT_PLANNING_EQUIPMENT = "eventPlanningEquipment";
export const EVENT_PLANNING_RESOURCE_PLAN = "eventPlanningResourcePlan";
export const EVENT_PLANNING_RECRUITMENT_PLAN = "eventPlanningRecruitmentPlan";
export const EVENT_PLANNING_RESERVE_CAPACITY = "eventPlanningReserveCapacity";
export const EVENT_PLANNING_PEAK_DAYS_ORDER = "eventPlanningPeakDaysOrder";
export const EVENT_PLANNING_PICK_PLAN = "eventPlanningPickPlan";
export const EVENT_PLANNING_FLOOR_CAPACITY = "eventPlanningFloorCapacity";

export const API_BASE = "/dcrp/api/dcrp";

export const REDUCER_TYPES = {
  GENERIC_SINGLE: "genericSingle",
  GENERIC_USE_ID: "genericUseId",
  GENERIC: "generic",
};

export const QUERY = (params) =>
  params
    ? `?${Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join("&")}`
    : "";

export const ENDPOINTS = {
  [CONFIG]: {
    storeKey: CONFIG,
    endpoint: {
      GET: `${API_BASE}/site_config/0/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [USER_INFO]: {
    storeKey: USER_INFO,
    endpoint: {
      GET: `${API_BASE}/accounts/users/current/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [DASHBOARDS]: {
    storeKey: DASHBOARDS,
    endpoint: {
      GET: `${API_BASE}/dashboards`,
      POST: `${API_BASE}/dashboards/`,
      PUT: (params) => `${API_BASE}/dashboards/${params.dashboardId}/`,
      DELETE: (params) => `${API_BASE}/dashboards/${params.dashboardId}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
    fallbackReducer: nonEndPointRelated,
  },
  [GLOBAL_FILTERS]: {
    storeKey: GLOBAL_FILTERS,
    endpoint: {
      GET: (routeParams) =>
        `${API_BASE}/get_filter_data/${
          routeParams.scenario
        }/${routeParams.scenarioCompare || routeParams.scenario}/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [VIEW_LAYOUTS]: {
    storeKey: VIEW_LAYOUTS,
    endpoint: {
      GET: `${API_BASE}/viewlayouts/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [VISUALISATIONS]: {
    storeKey: VISUALISATIONS,
    endpoint: {
      GET: `${API_BASE}/visualisations/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [VISUALISATION_DATA]: {
    storeKey: VISUALISATION_DATA,
    endpoint: {
      POST: (routeParams) =>
        `${API_BASE}/visualisation_data/${routeParams.scenario}/${
          routeParams.dataType
        }/${routeParams.startDate}/${routeParams.endDate}/${routeParams.unit}/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
    higherOrder: true, // Does this reducer manage sub-entities? eg dictionary of dictionaries.
    higherOrderKeyPath: "routeParams.dataType", // Where on the action meta can we find the key for each response for the higher order reducer?
  },
  [RAW_DATA_TYPES]: {
    storeKey: RAW_DATA_TYPES,
    endpoint: {
      GET: (routeParams) =>
        `${API_BASE}/get_data_types/${routeParams ? routeParams.scenario : 0}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [DATA_IS_LINKED]: {
    storeKey: DATA_IS_LINKED,
    endpoint: {
      GET: ({ scenario, dataType }) =>
        `${API_BASE}/data_is_linked/${scenario}/${dataType}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [UNLINK_DATA]: {
    storeKey: UNLINK_DATA,
    endpoint: {
      PUT: ({ scenario, dataType, alsoCopy }) =>
        `${API_BASE}/unlink_data/${scenario}/${dataType}/${alsoCopy}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [RAW_DATA]: {
    storeKey: RAW_DATA,
    endpoint: {
      GET: ({
        scenario,
        dataType,
        startOfWeekDate,
        endOfWeekDate,
        queryParameters = { offset: 0 },
      }) =>
        `${API_BASE}/items/${scenario}/${dataType}/${startOfWeekDate}/${endOfWeekDate}/false/${QUERY(
          queryParameters
        )}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [ITEM_LOOKUPS]: {
    storeKey: ITEM_LOOKUPS,
    endpoint: {
      GET: ({ scenario, dataType, startOfWeekDate, endOfWeekDate }) =>
        `${API_BASE}/items/${scenario}/${dataType}/${startOfWeekDate}/${endOfWeekDate}/true/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [ITEMS]: {
    storeKey: ITEMS,
    endpoint: {
      PUT: ({ scenario, dataType, id }) =>
        `${API_BASE}/items/${scenario}/${dataType}/${id}/`,
      DELETE: ({ scenario, dataType, id }) =>
        `${API_BASE}/items/${scenario}/${dataType}/${id}/`,
      POST: ({ scenario, dataType }) =>
        `${API_BASE}/items/${scenario}/${dataType}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [BULK_EDIT]: {
    storeKey: BULK_EDIT,
    endpoint: {
      PUT: (routeParams) =>
        `${API_BASE}/bulk_edit/${routeParams.scenario}/${
          routeParams.dataType
        }/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [COPY_PREVIOUS_WEEK]: {
    storeKey: COPY_PREVIOUS_WEEK,
    endpoint: {
      PUT: (routeParams) =>
        `${API_BASE}/copy_previous_week/${routeParams.scenario}/${
          routeParams.dataType
        }/${routeParams.startOfWeekDate}/${routeParams.endOfWeekDate}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [BULK_DELETE]: {
    storeKey: BULK_DELETE,
    endpoint: {
      PUT: (routeParams) =>
        `${API_BASE}/bulk_delete/${routeParams.scenario}/${
          routeParams.dataType
        }/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [SCENARIOS]: {
    storeKey: SCENARIOS,
    endpoint: {
      GET: (routeParams) =>
        `${API_BASE}/scenarios/${routeParams.showArchived || false}/${QUERY(
          routeParams.queryParameters
        )}`,
      POST: `${API_BASE}/scenarios/`,
      PUT: (routeParams) => `${API_BASE}/scenarios/${routeParams.id}/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [ARCHIVE_SCENARIO]: {
    storeKey: ARCHIVE_SCENARIO,
    endpoint: {
      PUT: `${API_BASE}/archive_scenarios/`,
    },
    reducer: REDUCER_TYPES.GENERIC_USE_ID,
  },
  [UNARCHIVE_SCENARIO]: {
    storeKey: UNARCHIVE_SCENARIO,
    endpoint: {
      PUT: `${API_BASE}/unarchive_scenarios/`,
    },
    reducer: REDUCER_TYPES.GENERIC_USE_ID,
  },
  [DELETE_SCENARIO]: {
    storeKey: DELETE_SCENARIO,
    endpoint: {
      PUT: `${API_BASE}/delete_scenarios/`,
    },
    reducer: REDUCER_TYPES.GENERIC_USE_ID,
  },
  [PERSIST_PARAMS]: {
    storeKey: PERSIST_PARAMS,
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
    fallbackReducer: nonEndPointRelated,
  },
  [SCENARIOS_COMPARE_KPIS]: {
    storeKey: SCENARIOS_COMPARE_KPIS,
    endpoint: {
      POST: (routeParams) =>
        `${API_BASE}/scenario_compare_kpis/${routeParams.scenario}/${
          routeParams.scenarioCompare
        }/${routeParams.startDate}/${
          routeParams.endDate
        }/${routeParams.inputOrOutput || "output"}/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [SCENARIOS_COMPARE_DATA]: {
    storeKey: SCENARIOS_COMPARE_DATA,
    endpoint: {
      GET: (routeParams) =>
        `${API_BASE}/scenario_compare_data/${routeParams.scenario}/${
          routeParams.scenarioCompare
        }/${routeParams.startDate}/${routeParams.endDate}/${
          routeParams.dataType
        }/${routeParams.cutOff}/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [SCENARIOS_COMPARE_DATA_SUMMARY]: {
    storeKey: SCENARIOS_COMPARE_DATA_SUMMARY,
    endpoint: {
      GET: (routeParams) =>
        `${API_BASE}/scenario_compare_data_summary/${routeParams.scenario}/${
          routeParams.scenarioCompare
        }/${routeParams.startDate}/${routeParams.endDate}/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [PUBLISH_SHIFT]: {
    storeKey: PUBLISH_SHIFT,
    endpoint: {
      GET: (routeParams) =>
        `${API_BASE}/publish/${routeParams.startDate}/${routeParams.endDate}/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [PUBLISH_STATUS]: {
    storeKey: PUBLISH_STATUS,
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
    fallbackReducer: nonEndPointRelated,
  },
  [CANCEL_OPTIMISE]: {
    storeKey: CANCEL_OPTIMISE,
    endpoint: {
      POST: (routeParams) =>
        `${API_BASE}/optimisations/${routeParams.scenario}/${
          routeParams.startDate
        }/${routeParams.endDate}/cancel/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [CANCEL_STATUS]: {
    storeKey: CANCEL_STATUS,
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
    fallbackReducer: nonEndPointRelated,
  },
  [OPTIMISE]: {
    storeKey: OPTIMISE,
    endpoint: {
      POST: (routeParams) =>
        `${API_BASE}/optimisations/${routeParams.scenario}/${
          routeParams.startDate
        }/${routeParams.endDate}/`,
      GET: (routeParams) => `${API_BASE}/optimisations/${routeParams.jobId}/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
    fallbackReducer: nonEndPointRelated,
  },
  [OPTIMISE_STATUS]: {
    storeKey: OPTIMISE_STATUS,
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
    fallbackReducer: nonEndPointRelated,
  },
  [OPTIMISE_ISSUES]: {
    storeKey: OPTIMISE_ISSUES,
    endpoint: {
      GET: (routeParams) =>
        `${API_BASE}/optimisations/${routeParams.jobId}/validation/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [CHECK_IS_OPTIMISE]: {
    storeKey: CHECK_IS_OPTIMISE,
    endpoint: {
      GET: (routeParams) =>
        `${API_BASE}/optimisations/${routeParams.scenario}/${
          routeParams.startDate
        }/${routeParams.endDate}/latest/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [COPY_SHIFTS]: {
    storeKey: COPY_SHIFTS,
    endpoint: {
      POST: (routeParams) =>
        `${API_BASE}/scenarios/${routeParams.scenario}/${
          routeParams.scenarioDest
        }/copy_shifts_and_clear_replan/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [REPLACE_PLAN]: {
    storeKey: REPLACE_PLAN,
    endpoint: {
      POST: (routeParams) =>
        `${API_BASE}/copy_shifts/${routeParams.scenario}/${
          routeParams.scenarioDest
        }/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [CLEAR_REPLAN]: {
    storeKey: CLEAR_REPLAN,
    endpoint: {
      POST: (routeParams) =>
        `${API_BASE}/scenarios/${routeParams.scenario}/clear_replan/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [EVENTS]: {
    storeKey: EVENTS,
    endpoint: {
      GET: (routeParams) => `${API_BASE}/events/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [EVENTS_SUMMARY]: {
    storeKey: EVENTS_SUMMARY,
    endpoint: {
      GET: (routeParams) =>
        `${API_BASE}/events/summary/${routeParams.scenario}/${
          routeParams.groupId
        }/${routeParams.size}/`,
      POST: (routeParams) =>
        `${API_BASE}/events/clear_from/${routeParams.scenario}/${
          routeParams.groupId
        }/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [EVENTS_SUMMARY_VIEWED]: {
    storeKey: EVENTS_SUMMARY_VIEWED,
    endpoint: {
      POST: (routeParams) =>
        `${API_BASE}/events/user_is_up_to_date/${routeParams.scenario}/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [AVAILABLE_VOLUME_DATA_SOURCES]: {
    storeKey: AVAILABLE_VOLUME_DATA_SOURCES,
    endpoint: {
      GET: ({ volumeType, startOfWeekDate, endOfWeekDate }) =>
        `${API_BASE}/get_available_volume_data_sources/${volumeType}/${startOfWeekDate}/${endOfWeekDate}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [CURRENT_VOLUMES]: {
    storeKey: CURRENT_VOLUMES,
    endpoint: {
      GET: ({
        scenario,
        volumeType,
        startOfWeekDate,
        endOfWeekDate,
        dateType,
        days,
        timePeriod = "week",
      }) =>
        `${API_BASE}/get_volume_from_source/${scenario}/${volumeType}/current/${startOfWeekDate}/${endOfWeekDate}/${timePeriod}/${days.join(
          ","
        )}/${dateType}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [VOLUME_FROM_SOURCE]: {
    storeKey: VOLUME_FROM_SOURCE,
    endpoint: {
      GET: ({
        scenario,
        volumeType,
        source,
        startOfWeekDate,
        endOfWeekDate,
        days,
        dateType,
        timePeriod = "week",
      }) =>
        `${API_BASE}/get_volume_from_source/${scenario}/${volumeType}/${source}/${startOfWeekDate}/${endOfWeekDate}/${timePeriod}/${days.join(
          ","
        )}/${dateType}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [UPDATE_VOLUMES]: {
    storeKey: UPDATE_VOLUMES,
    endpoint: {
      PUT: ({ scenario, startOfWeekDate, endOfWeekDate, timePeriod }) =>
        `${API_BASE}/update_volumes/${scenario}/${startOfWeekDate}/${endOfWeekDate}/${timePeriod}/`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [PRE_FLIGHT_DATA]: {
    storeKey: PRE_FLIGHT_DATA,
    endpoint: {
      GET: ({ scenario, startDate, endDate }) =>
        `${API_BASE}/scenarios/${scenario}/preflight_data/${startDate}/${endDate}`,
    },
    reducer: REDUCER_TYPES.GENERIC_SINGLE,
  },
  [KPI_REPORT_PICK_VOLUME]: {
    storeKey: KPI_REPORT_PICK_VOLUME,
    endpoint: {
      POST: ({ scenarioA, scenarioB, startDate, endDate }) =>
        `${API_BASE}/replan_kpi/pick_volume/${scenarioA}/${scenarioB}/${startDate}/${endDate}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [KPI_COST_SUMMARY]: {
    storeKey: KPI_COST_SUMMARY,
    endpoint: {
      POST: ({ scenarioA, scenarioB, startDate, endDate }) =>
        `${API_BASE}/replan_kpi/cost_summary/${scenarioA}/${scenarioB}/${startDate}/${endDate}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [KPI_UTILISATION_REPORT]: {
    storeKey: KPI_UTILISATION_REPORT,
    endpoint: {
      POST: ({ scenarioA, scenarioB, startDate, endDate }) =>
        `${API_BASE}/replan_kpi/utilisation_report/${scenarioA}/${scenarioB}/${startDate}/${endDate}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [KPI_FACILITY_REPORT]: {
    storeKey: KPI_FACILITY_REPORT,
    endpoint: {
      POST: ({ scenarioA, scenarioB, startDate, endDate }) =>
        `${API_BASE}/replan_kpi/facility_report/${scenarioA}/${scenarioB}/${startDate}/${endDate}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [KPI_STORAGE_REPORT]: {
    storeKey: KPI_STORAGE_REPORT,
    endpoint: {
      POST: ({ scenarioA, scenarioB, startDate, endDate }) =>
        `${API_BASE}/replan_kpi/storage_report/${scenarioA}/${scenarioB}/${startDate}/${endDate}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [KPI_PRODUCTIVITY_REPORT]: {
    storeKey: KPI_PRODUCTIVITY_REPORT,
    endpoint: {
      POST: ({ scenarioA, scenarioB, startDate, endDate }) =>
        `${API_BASE}/replan_kpi/productivity_report/${scenarioA}/${scenarioB}/${startDate}/${endDate}/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [EVENT_PLANNING_SCENARIOS]: {
    storeKey: EVENT_PLANNING_SCENARIOS,
    endpoint: {
      GET: ({ fromDate, toDate }) =>
        `${API_BASE}/event_planning/scenarios/${fromDate}/${toDate}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [EVENT_PLANNING_PEAK_DAYS]: {
    storeKey: EVENT_PLANNING_PEAK_DAYS,
    endpoint: {
      GET: ({
        fromDate,
        toDate,
        fromDateFilter,
        toDateFilter,
        durationAggregator,
        scenarios,
      }) =>
        `${API_BASE}/event_planning/peak_days/${fromDate}/${toDate}?${
          scenarios ? scenarios : ""
        }from_date=${fromDateFilter}&to_date=${toDateFilter}&filter_by=${durationAggregator}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [EVENT_PLANNING_PEAK_DAYS_ORDER]: {
    storeKey: EVENT_PLANNING_PEAK_DAYS_ORDER,
    endpoint: {
      GET: ({
        fromDate,
        toDate,
        fromDateFilter,
        toDateFilter,
        durationAggregator,
        scenarios,
      }) =>
        `${API_BASE}/event_planning/peak_days_order/${fromDate}/${toDate}?${
          scenarios ? scenarios : ""
        }from_date=${fromDateFilter}&to_date=${toDateFilter}&filter_by=${durationAggregator}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [INBOUND_VOLUME]: {
    storeKey: INBOUND_VOLUME,
    endpoint: {
      GET: ({
        fromDate,
        toDate,
        fromDateFilter,
        toDateFilter,
        durationAggregator,
        scenarios,
      }) =>
        `${API_BASE}/event_planning/inbound_volume/${fromDate}/${toDate}?${
          scenarios ? scenarios : ""
        }&from_date=${fromDateFilter}&to_date=${toDateFilter}&filter_by=${durationAggregator}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [EVENT_PLANNING_USER_SELECTED_SCENARIOS]: {
    storeKey: EVENT_PLANNING_USER_SELECTED_SCENARIOS,
    endpoint: {
      GET: () => `${API_BASE}/event_planning/user_scenarios/`,
      POST: () => `${API_BASE}/event_planning/user_scenarios/`,
      PUT: () => `${API_BASE}/event_planning/user_scenarios/`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [EVENT_PLANNING_VOLUME_BY_WEEK]: {
    storeKey: EVENT_PLANNING_VOLUME_BY_WEEK,
    endpoint: {
      GET: ({
        fromDate,
        toDate,
        fromDateFilter,
        toDateFilter,
        durationAggregator,
        scenarios,
      }) =>
        `${API_BASE}/event_planning/volume_by_week/${fromDate}/${toDate}?${
          scenarios ? scenarios : ""
        }from_date=${fromDateFilter}&to_date=${toDateFilter}&filter=${durationAggregator}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [EVENT_PLANNING_PICK_VOLUME]: {
    storeKey: EVENT_PLANNING_PICK_VOLUME,
    endpoint: {
      GET: ({
        fromDate,
        toDate,
        fromDateFilter,
        toDateFilter,
        durationAggregator,
        scenarios,
      }) =>
        `${API_BASE}/event_planning/pick_volume/${fromDate}/${toDate}?${
          scenarios ? scenarios : ""
        }&from_date=${fromDateFilter}&to_date=${toDateFilter}&filter_by=${durationAggregator}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [EVENT_PLANNING_PICK_PLAN]: {
    storeKey: EVENT_PLANNING_PICK_PLAN,
    endpoint: {
      GET: ({
        fromDate,
        toDate,
        fromDateFilter,
        toDateFilter,
        durationAggregator,
        scenarios,
        additionalFilters,
      }) =>
        `${API_BASE}/event_planning/pick_plan/${fromDate}/${toDate}?${
          scenarios ? scenarios : ""
        }&from_date=${fromDateFilter}&to_date=${toDateFilter}&filter_by=${durationAggregator}${
          additionalFilters ? `&${additionalFilters}` : ""
        }`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [EVENT_PLANNING_EQUIPMENT]: {
    storeKey: EVENT_PLANNING_EQUIPMENT,
    endpoint: {
      GET: ({
        fromDate,
        toDate,
        fromDateFilter,
        toDateFilter,
        durationAggregator,
        scenarios,
      }) =>
        `${API_BASE}/event_planning/equipment/${fromDate}/${toDate}?${
          scenarios ? scenarios : ""
        }&from_date=${fromDateFilter}&to_date=${toDateFilter}&filter_by=${durationAggregator}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [EVENT_PLANNING_RESOURCE_PLAN]: {
    storeKey: EVENT_PLANNING_RESOURCE_PLAN,
    endpoint: {
      GET: ({
        fromDate,
        toDate,
        fromDateFilter,
        toDateFilter,
        durationAggregator,
        scenarios,
      }) =>
        `${API_BASE}/event_planning/resource_plan/${fromDate}/${toDate}?${
          scenarios ? scenarios : ""
        }&from_date=${fromDateFilter}&to_date=${toDateFilter}&filter_by=${durationAggregator}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [EVENT_PLANNING_RECRUITMENT_PLAN]: {
    storeKey: EVENT_PLANNING_RECRUITMENT_PLAN,
    endpoint: {
      GET: ({
        fromDate,
        toDate,
        fromDateFilter,
        toDateFilter,
        durationAggregator,
        scenarios,
      }) =>
        `${API_BASE}/event_planning/recruitment_plan/${fromDate}/${toDate}?${
          scenarios ? scenarios : ""
        }&from_date=${fromDateFilter}&to_date=${toDateFilter}&filter_by=${durationAggregator}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [EVENT_PLANNING_RESERVE_CAPACITY]: {
    storeKey: EVENT_PLANNING_RESERVE_CAPACITY,
    endpoint: {
      GET: ({
        fromDate,
        toDate,
        fromDateFilter,
        toDateFilter,
        durationAggregator,
        scenarios,
      }) =>
        `${API_BASE}/event_planning/reserve_capacity/${fromDate}/${toDate}?${
          scenarios ? scenarios : ""
        }&from_date=${fromDateFilter}&to_date=${toDateFilter}&filter_by=${durationAggregator}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
  [EVENT_PLANNING_FLOOR_CAPACITY]: {
    storeKey: EVENT_PLANNING_FLOOR_CAPACITY,
    endpoint: {
      GET: ({
        fromDate,
        toDate,
        fromDateFilter,
        toDateFilter,
        durationAggregator,
        scenarios,
      }) =>
        `${API_BASE}/event_planning/floor_capacity/${fromDate}/${toDate}?${
          scenarios ? scenarios : ""
        }&from_date=${fromDateFilter}&to_date=${toDateFilter}&filter_by=${durationAggregator}`,
    },
    reducer: REDUCER_TYPES.GENERIC,
  },
};

export const URLS = {
  tsv: {
    downloadLink: (routeParams) =>
      `${API_BASE}/download_grid_data/${routeParams.scenario}/${
        routeParams.dataType
      }/${routeParams.startOfWeekDate}/${routeParams.endOfWeekDate}/tsv/`,
    uploadLink: (routeParams) =>
      `${API_BASE}/upload_grid_data/${routeParams.scenario}/${
        routeParams.dataType
      }/${routeParams.startOfWeekDate}/${routeParams.endOfWeekDate}/`,
    downloadForCopyToClipboard: (routeParams) =>
      `${API_BASE}/download_grid_data/${routeParams.scenario}/${
        routeParams.dataType
      }/${routeParams.startOfWeekDate}/${routeParams.endOfWeekDate}/copydata/`,
  },
  csv: {
    downloadCSVLink: (routeParams) =>
      `${API_BASE}/download_grid_data/${routeParams.scenario}/${
        routeParams.dataType
      }/${routeParams.startOfWeekDate}/${routeParams.endOfWeekDate}/csv/`,
  },
  xlsx: {
    downloadScenarioComparison: (routeParams) =>
      `${API_BASE}/scenario_compare_data_download/${routeParams.scenario}/${
        routeParams.scenarioCompare
      }/${routeParams.startDate}/${routeParams.endDate}/${
        routeParams.dataType
      }/`,
  },
};

export const STATIC_REDUCERS = [];

export const ENDPOINTS_ARRAY = Object.values(ENDPOINTS);
